import styled from "styled-components";
import React from "react";

const ConnectorRender = styled.div<{ direction: "left" | "right" | "bottom" | "top" }>`
    position: absolute;

    ${(props) =>
        props.direction === "left"
            ? `
                left: 0;
                top: 20px;
            `
            : props.direction === "right"
            ? `
                right: 0;
                top: 20px;

            `
            : props.direction === "top"
            ? `
                top: 0;
                left: 20px;
            `
            : `
                bottom: 0;
                left: 20px;
            `}
`;

export const Connector = ({ nodeid }: { nodeid: string }) => {
    return (
        <>
            {["left", "right", "bottom", "top"].map((direction) => {
                return (
                    <ConnectorRender
                        key={direction}
                        direction={direction as "left" | "right" | "bottom" | "top"}
                        id={`${nodeid}-${direction}`}
                    />
                );
            })}
        </>
    );
};
